import React from 'react';
import '../../../src/html.scss'
import { useHistory } from 'react-router-dom';

const PricacyPolicy = () => {
    let history = useHistory()
    const goback = () => {
        history.goBack()
    }
    return (
        <div className="article">
            <h2 className='header'><span className='back' onClick={goback}>&lt;</span>Politica sulla Privacy</h2>
            <body class="article">
                <p><strong>Dreamehome Informativa Privacy</strong></p>
                <p><strong>Introduzione</strong></p>
                <p>L'attività "Dreamehome" è gestita da Dreame Innovation Technology (Suzhou) Co., Ltd. e dalle sue affiliate (di
                    seguito denominate "noi" o "Dreame") per fornirti una piattaforma (o un servizio) per i servizi di controllo e
                    gestione dei dispositivi hardware intelligenti. Capiamo e comprendiamo l'importanza delle informazioni personali
                    per
                    te e faremo del nostro meglio per proteggere la sicurezza delle tue informazioni personali. Adotteremo le
                    corrispondenti misure di protezione della sicurezza per proteggere le tue informazioni personali secondo gli
                    standard di sicurezza riconosciuti dal settore.</p>
                <p>.</p>
                <p>Prima di utilizzare i nostri prodotti (o servizi), ti preghiamo di leggere attentamente e comprendere
                    l'Informativa
                    Privacy dell'Dreamehome.</p>
                <p>Se sei minorenne, bisogna avere l'autorizzazione dei tuoi genitori o tutori legali per utilizzare questa App e
                    chiedere loro di leggere questi termini con te insieme.</p>
                <p>Abbiamo tenuto in massima considerazione le tue esigenze durante la formulazione della presente Informativa
                    Privacy. È molto importante che tu comprenda appieno la nostra raccolta delle informazioni personali e le
                    pratiche
                    di utilizzo, nonché i nostri sforzi per assicurarti che possa gestire e controllare le tue informazioni
                    personali
                    fornite a noi. La presente Informativa Privacy copre il modo in cui raccogliamo, utilizziamo, divulghiamo,
                    elaboriamo e conserviamo le informazioni che ci fornisci quando utilizzi la nostra app. Ci atterremo
                    rigorosamente
                    alla presente Informativa Privacy durante l'utilizzo delle tue informazioni.</p>
                <p> Questa Informativa Privacy ti aiuterà a capire:</p>
                <p> 1. Quali informazioni raccogliamo e come le usiamo</p>
                <p> 2. Come utilizziamo i cookie e le tecnologie simili</p>
                <p> 3. Come affidiamo l’elaborazione, la condivisione, il trasferimento e la divulgazione pubblica delle tue
                    informazioni personali</p>
                <p> 4. Come conserviamo e proteggiamo le tue informazioni personali</p>
                <p> 5. I tuoi diritti</p>
                <p> 6. Come gestiamo la trasmissione transfrontaliera dei dati</p>
                <p> 7. Le nostre informazioni di contatto</p>
                <p> 8. Come aggiorniamo l'Informativa Privacy</p>
                <p> Appendice I: I Dettagli di SDK di Terze Parti</p>
                <p>Il nostro obiettivo finale è offrirti la migliore esperienza utente. Abbiamo Responsabile della Protezione dei
                    Dati
                    (RPD) dedicato con sede in diversi paesi e regioni per gestire i problemi dei dati personali. In caso di domande
                    sulla presente Informativa Privacy, è possibile contattare il RPD corrispondente con le informazioni di contatto
                    nella Sezione VII. Il nostro RPD risponderà alla tua richiesta entro il tempo richiesto dalle politiche e dalle
                    leggi nazionali pertinenti. Se non sei soddisfatto della nostra risposta, soprattutto quando ritieni che il
                    nostro
                    comportamento di gestione delle informazioni personali abbia causato un danno ai tuoi legittimi diritti e
                    interessi,
                    puoi intentare una causa presso il tribunale del popolo competente, presentare un reclamo alle agenzie di
                    regolamentazione del governo o risolvere i tuoi problemi con altri approcci esterni.</p>
                <p><strong>I. Quali informazioni raccogliamo e come le usiamo</strong></p>
                <p>Le informazioni personali si riferiscono a tutte le informazioni registrate elettronicamente o in altri modi che
                    possono essere utilizzate da sole o in combinazione con altre informazioni per identificare una persona fisica
                    specifica.</p>
                <p>Le Informazioni Personali Sensibili si riferiscono alle informazioni che una volta trapelate, fornite
                    illegalmente
                    o utilizzate in modo improprio, potrebbero mettere in pericolo la sicurezza personale e della proprietà, o
                    portare
                    facilmente danni alla reputazione personale, alla salute mentale &amp; fisica o ai trattamenti discriminatori,
                    ecc.
                    Le Informazioni Personali Sensibili includono ma non sono limitate ai numeri di identificazione, le informazioni
                    biometriche personali, le informazioni sul conto bancario, le informazioni sulla proprietà, le registrazioni di
                    luoghi in cui si trovano, le informazioni sulle transazioni e le informazioni personali di minori di età
                    inferiore
                    ai 14 anni (inclusa), ecc.</p>
                <p>Lo scopo della raccolta delle tue informazioni personali è fornirti i prodotti e/o servizi e garantiamo che le
                    utilizzeremo in conformità con le leggi, i regolamenti e altri documenti normativi applicabili. Hai il diritto
                    di
                    scegliere se fornire le tue informazioni o no. Ma nella maggior parte dei casi, se non le fornisci, potremmo non
                    essere in grado di fornirti i servizi corrispondenti né rispondere alle tue richieste.</p>
                <p>(I) Dreamehome raccoglie e elabora le tue informazioni personali per fornire i servizi fondamentali</p>
                <p>(1) Connessione e gestione del dispositivo</p>
                <p>Al fine di fornire i nostri servizi in modo che tu possa connettere e gestire in sicurezza i tuoi dispositivi
                    intelligenti, potremmo raccogliere le tue informazioni Wi-Fi, le informazioni sulla posizione, le informazioni
                    sull'account di accesso, le informazioni sul telefono cellulare correlato, le informazioni sul dispositivo
                    intelligente e le informazioni associate del tuo account Dreame e del dispositivo intelligente. Le informazioni
                    verranno utilizzate per abilitare le funzionalità come Connessione Rapida, Connessione, Trova Dispositivi nelle
                    Vicinanze e Gestione Dispositivi. Nello specifico, le informazioni che raccogliamo includono:</p>
                <p>Le informazioni sull'account di accesso: il nome utente, la password, il nickname, la foto del profilo,
                    l’indirizzo
                    e-mail e il numero di telefono dell'account Dreame. Tra questi, il nome utente, la password, il numero di
                    telefono e
                    l'indirizzo e-mail sono informazioni personali sensibili. Tali informazioni vengono raccolte per verificare la
                    tua
                    identità e aiutarti a ottenere l'autorizzazione per accedere al server con il tuo account dell'Dreamehome. Il
                    nome
                    utente e la password immessi verranno crittografati e trasmessi al server Dreame per l'autenticazione
                    dell'accesso.
                </p>
                <p>Le informazioni relative al telefono cellulare: l’identificazione del dispositivo (IMEI/OAID, indirizzo Mac e ID
                    Android), il modello del telefono, la versione del sistema, il paese o la regione, la dimensione e risoluzione
                    dello
                    schermo, la CPU e le relative informazioni sul dispositivo di visualizzazione. Queste informazioni vengono
                    raccolte
                    per consentirti di connettere l'Dreamehome con i tuoi dispositivi intelligenti.</p>
                <p>Le informazioni sul dispositivo intelligente: il nome del dispositivo, il modello, la versione, il produttore,
                    l’identificatore, l’indirizzo MAC, l’indirizzo IP, lo stato operativo, gli attributi personalizzati,
                    l’impostazione
                    dei parametri di eventi aziendali, il controllo del dispositivo e i record di utilizzo. Queste informazioni
                    vengono
                    raccolte per associare il dispositivo intelligente in modo da poter controllare e gestire il dispositivo,
                    impostare
                    la proprietà e i parametri del dispositivo e visualizzare lo stato di funzionamento e le cronologie del
                    dispositivo.
                </p>
                <p>(2) Aggiornamento dell'Dreamehome e del dispositivo intelligente</p>
                <p>Per assicurarti che tu possa usufruire continuamente dei nostri servizi più recenti, potremmo utilizzare le
                    informazioni sulla versione dell'Dreamehome e il modello del telefono per fornire i servizi aggiornati. Inoltre,
                    potremmo anche raccogliere l'elenco dei dispositivi collegati e le informazioni sulla versione per fornire i
                    servizi
                    aggiornati in modo che tu possa utilizzare l'ultima versione dei nostri servizi (inclusa la versione del
                    firmware).
                    Dreamehome fornisce solo i servizi aggiornati per i tuoi dispositivi intelligenti. Il produttore del dispositivo
                    intelligente fornisce il firmware corrispondente ed è responsabile della qualità della versione e dei risultati
                    dell'aggiornamento.</p>
                <p>Se scegli di non fornire queste informazioni, non sarai in grado di aggiornare l'Dreamehome e il tuo dispositivo
                    intelligente.</p>
                <p>(3) Feedback sui problemi online</p>
                <p>Al fine di aiutarti a risolvere efficacemente i possibili problemi dell'Dreamehome e del tuo dispositivo
                    intelligente, offriamo un servizio di feedback dei problemi online che richiede le tue informazioni personali
                    tipo:
                    i registri dell'Dreamehome e del tuo dispositivo intelligente, le informazioni di contatto, le descrizioni dei
                    problemi e foto e video pertinenti. I registri dell'app e del dispositivo includono lo stato del dispositivo, le
                    informazioni rilevate dai sensori, i record di funzionamento del dispositivo, gli identificatori del
                    dispositivo,
                    ecc. Queste informazioni vengono raccolte per analizzare e identificare le cause del problema. Le tue
                    informazioni
                    di contatto vengono raccolte in modo che possiamo rintracciare e seguire il caso e aiutarti meglio a risolvere
                    il
                    problema.</p>
                <p>Le tue informazioni personali verranno utilizzate solo per analizzare e risolvere i problemi e non saranno
                    divulgate pubblicamente o utilizzate per interessi commerciali. Se non fornisci tali informazioni, non saremo in
                    grado di identificare né risolvere efficacemente i tuoi problemi.</p>
                <p>(II) Dreamehome raccoglie e elabora le tue informazioni personali per fornire le funzioni aggiuntive</p>
                <p>Oltre a fornire i servizi fondamentali dell'Dreamehome, potremmo anche aver bisogno di raccogliere e utilizzare
                    le
                    tue informazioni personali per alcune funzioni aggiuntive. Se non fornisci queste informazioni, puoi comunque
                    utilizzare i servizi fondamentali dell'Dreamehome, ma non saresti in grado di utilizzare le funzioni aggiuntive
                    che
                    possono offrirti maggiore comodità. Oltre ai servizi fondamentali, l'Dreamehome offre anche:</p>
                <p>Programma di Miglioramento dell'Esperienza Utente:</p>
                <p>Al fine di migliorare la tua esperienza utente, abbiamo bisogno di raccogliere i registri dell'Dreamehome,
                    inclusi
                    i registri del processo della chiave crittografata, i registri degli eventi, i registri dei guasti, gli eventi
                    aziendali, l'utilizzo di ciascuna interfaccia, ecc. Le tue informazioni personali sensibili non verranno
                    registrate
                    nei registri.</p>
                <p>Le tue informazioni personali verranno utilizzate nei seguenti modi: le informazioni di cui sopra menzionate
                    saranno automaticamente raccolte e caricate sul server; le informazioni di registro verranno analizzate per
                    diagnosticare lo stato dell'operazione e analizzare l'utilizzo dell'app.</p>
                <p>Se non fornisci queste informazioni, l'Dreamehome non sarà in grado di migliorare tempestivamente la tua
                    esperienza
                    utente, ma puoi comunque utilizzare i servizi fondamentali dell'Dreamehome.</p>
                <p>(II) Potremmo raccogliere le tue informazioni personali da terzi</p>
                <p>In alcune circostanze, potremmo acquisire legalmente le tue informazioni personali da terzi.</p>
                <p>Con la tua autorizzazione, collaboreremo con fornitori di servizi terzi nella gestione dei tuoi dispositivi
                    intelligenti, durante il quale raccoglieremo le tue informazioni personali da fornitori di servizi terzi. Se
                    gestisci il tuo dispositivo intelligente con un account di terze parti, otterremo le tue informazioni personali
                    quando la tua app sarà collegata all'account di terze parti. Verranno raccolte le seguenti informazioni:</p>
                <p>Le informazioni del tuo account di terze parti, incluso il tuo nickname e la foto del profilo che verranno
                    mostrate
                    nell'Dreamehome;</p>
                <p>Le informazioni sul dispositivo e sulla rete, incluso l'identificativo del dispositivo, l'indirizzo MAC e il
                    numero
                    di serie del dispositivo per riconoscere il dispositivo corrente e abilitare il controllo di sicurezza.</p>
                <p>Se il trattamento delle tue informazioni personali per le attività commerciali supera l'ambito della tua
                    autorizzazione e del tuo consenso originale quando fornisci le informazioni a un fornitore di servizi terzi,
                    otterremo il tuo chiaro consenso prima di gestire le tue informazioni. Inoltre, ci atteneremo rigorosamente alle
                    leggi e ai regolamenti pertinenti e richiederemo ai fornitori di servizi terzi pertinenti di garantire la
                    legalità
                    delle informazioni che forniscono.</p>
                <p>(IV) Informazioni non personali</p>
                <p>Potremmo anche raccogliere altre informazioni che non possono essere utilizzate per identificare un individuo
                    specifico (ad esempio le informazioni che non sono identificabili personalmente), come i dati statistici
                    generati
                    quando si utilizza un servizio specifico come i comportamenti degli utenti (inclusi clic, salti di pagina e
                    tempo di
                    navigazione). Queste informazioni vengono raccolte per migliorare i nostri servizi. I tipi e le quantità di
                    informazioni raccolte dipendono da come utilizzi i nostri prodotti e/o servizi. Raccoglieremo queste
                    informazioni
                    per aiutarci a fornire le informazioni più utente-amichevole e comprendere meglio le preferenze dei clienti per
                    il
                    nostro sito Web, prodotti e servizi in modo da poter ottimizzare i nostri servizi. Nella presente Informativa
                    Privacy, i dati raccolti devono essere considerati informazioni non personali. Quando combiniamo informazioni
                    non
                    personali con informazioni personali in uso, le informazioni non personali devono essere considerate
                    informazioni
                    personali.</p>
                <p><strong>II. Come utilizziamo i Cookie e le tecnologie simili</strong></p>
                <p>Per garantire il normale funzionamento dell'Dreamehome, memorizzeremo un piccolo file di dati denominato Cookie
                    sul
                    tuo dispositivo. I Cookie normalmente includono gli identificatori, i nomi di siti e alcuni numeri e caratteri.
                    Con
                    l'aiuto dei Cookie, l'Dreamehome può memorizzare l'account di accesso al sito Web, le preferenze e altri dati.
                </p>
                <p>Non utilizzeremo i Cookie per scopi diversi da quelli dichiarati nella presente Informativa Privacy. Puoi gestire
                    o
                    eliminare i Cookie in base alle tue preferenze. Ma se lo fai, in alcuni casi, il tuo accesso sicuro
                    all'Dreamehome
                    potrebbe essere compromesso e potresti dover modificare le impostazioni utente ogni volta che accedi
                    all'Dreamehome.
                </p>
                <p><strong>III. Come affidiamo l’elaborazione, la condivisione, il trasferimento e la divulgazione pubblica delle
                    tue
                    informazioni personali</strong></p>
                <p>(I) Elaborazione affidata</p>
                <p>In alcune circostanze, Dreame potrebbe affidare ad altre società l’elaborazione dei tuoi dati personali, come
                    contattarti, inviare e-mail o fornire supporto tecnico per nostro conto. Queste società possono utilizzare le
                    tue
                    informazioni personali solo per fornirti i servizi per nostro conto.</p>
                <p>Firmeremo un accordo di stretta riservatezza o un accordo per l’elaborazione delle informazioni personali con la
                    parte incaricata e richiederemo loro di gestire le informazioni personali in conformità con la presente
                    Informativa
                    Privacy e adottare le misure di riservatezza e sicurezza pertinenti.</p>
                <p>(II) Condivisione</p>
                <p>In circostanze generali, Dream non condividerà le tue informazioni personali con altre società, organizzazioni o
                    individui tranne nei seguenti casi:</p>
                <p>1. Con il tuo consenso, condivideremo le informazioni all'interno della tua autorizzazione con una terza parte,
                    che
                    include le informazioni e la configurazione dei tuoi prodotti per la casa intelligente dei tuoi parenti e amici
                    che
                    condividono i prodotti con te per aiutarli a ottenere un rapido accesso al software e i servizi sui loro
                    dispositivi
                    terminali.</p>
                <p>2. Alcuni servizi dell'Dreamehome, come hosting di siti web, analisi dei dati, gestione di pagamenti e carte di
                    credito, fornitura di infrastrutture, servizi IT, servizi di assistenza clienti, servizi di invio di e-mail e
                    altri
                    servizi simili, sono forniti da fornitori di servizi terzi. Per questo motivo, dobbiamo fornire alcune delle tue
                    informazioni personali ai fornitori di servizi terzi in modo che possano fornirci tali servizi.</p>
                <p>3. Potremmo divulgare le tue informazioni personali ai clienti e altri partner commerciali che direttamente o
                    indirettamente forniscono i dispositivi intelligenti e/o reti e sistemi per l'accesso e l'utilizzo del nostro
                    sito
                    Web e dei nostri servizi.</p>
                <p>4. Se Dreame sia coinvolta in una riorganizzazione, fusione, vendita di beni, joint venture, abalienazione,
                    trasferimento o altre circostanze in cui tutta o parte della nostra attività, beni o azioni deve essere ceduta
                    (inclusi ma non limitati a bancarotte o simili procedimenti relativi alle circostanze di cui sopra menzionate),
                    potremmo divulgare le tue informazioni personali a società affiliate o ad altre terze parti. Prima di ciò,
                    riceverai
                    una chiara notifica via e-mail e/o sul nostro sito web in merito al cambio di proprietà, all'incompatibilità del
                    nuovo utilizzo delle informazioni personali e all'autorizzazione delle tue informazioni personali.</p>
                <p>5. Se riteniamo in buona fede che l'accesso, l'uso, la conservazione o la divulgazione delle informazioni sia
                    ragionevolmente necessario per: (a) rispettare le leggi e i regolamenti applicabili; (b) rispettare le procedure
                    legali; (c) rispondere ai requisiti delle istituzioni pubbliche e delle autorità governative, comprese quelle al
                    di
                    fuori del paese/regione in cui vivi; (d) soddisfare i nostri termini e condizioni; (e) proteggere le nostre
                    operazioni, attività e sistemi; (f) proteggere i diritti, la privacy, la sicurezza o la proprietà nostra e/o di
                    altri utenti, incluso te; e (g) cercare i rimedi disponibili o limitare i risarcimenti dei danni che potremmo
                    dover
                    fornire.</p>
                <p>6. Potremmo divulgare le tue informazioni personali alle nostre filiali o società affiliate per svolgere
                    regolarmente attività commerciali.</p>
                <p>7. Condivideremo i dati necessari con terze parti tramite interfacce di programmazione delle applicazioni (API) e
                    pacchetti di sviluppo di strumenti software (SDK). Gli SDK di terze parti variano a seconda delle versioni,
                    generalmente inclusi i tipi di accesso di account di terze parti, i tipi di condivisione e i tipi di pagamento
                    di
                    account di terze parti, i tipi di push del produttore, i tipi di statistiche, ecc. Condurremo rigorose ispezioni
                    di
                    sicurezza sulle terze parti e concorderemo sulle misure di protezione dei dati. Nell'Appendice I abbiamo
                    elencato i
                    dettagli degli SDK di terze parti a cui abbiamo autorizzato l'accesso, si prega di leggerlo attentamente. La
                    nostra
                    Informativa Privacy non si applica ai prodotti o servizi forniti da terze parti. Le tue informazioni personali
                    possono essere raccolte quando utilizzi questi prodotti o servizi. Pertanto, ti consigliamo vivamente di leggere
                    l'informativa privacy delle terze parti, proprio come la nostra. Non abbiamo alcuna responsabilità e controllo
                    su
                    come le terze parti utilizzano le informazioni che raccolgono da te. La nostra Informativa Privacy non si
                    applica ad
                    altri siti web collegati tramite i nostri servizi. Dovresti essere responsabile della sicurezza delle tue
                    informazioni personali durante l'interazione con i siti web collegati. Prima di accedere per la prima volta alla
                    pagina di terze parti, il fornitore di servizi terzi ti mostrerà gli accordi e le dichiarazioni sulla privacy
                    pertinenti. Si prega di leggere attentamente le loro dichiarazioni.</p>
                <p>(III) Trasferimento</p>
                <p>Dreame non trasferirà le tue informazioni personali a altre società, organizzazioni o individui tranne nei
                    seguenti
                    casi:</p>
                <p>1. Con il tuo esplicito consenso: trasferiremo le tue informazioni personali ad altre parti solo dopo aver
                    ottenuto
                    il tuo esplicito consenso;</p>
                <p>2. Se Dream è coinvolto in una fusione, acquisizione o liquidazione fallimentare che richiede il trasferimento di
                    informazioni personali, richiederemo che la nuova società o organizzazione che detiene i tuoi dati personali
                    continui a essere vincolata dalla presente Informativa Privacy, altrimenti richiederemo l'azienda o
                    l'organizzazione
                    per acquisire nuovamente l'autorizzazione da parte tua.</p>
                <p>(IV) Divulgazione al pubblico</p>
                <p>Non divulghiamo pubblicamente le tue informazioni personali se non nelle seguenti circostanze:</p>
                <p>1. Con il tuo esplicito consenso;</p>
                <p>2. Quando abbiamo una base giuridica: potremmo divulgare pubblicamente le tue informazioni personali in
                    conformità
                    con la legge o in base alle procedure legali, contenziosi o requisiti obbligatori delle autorità governative.
                </p>
                <p><strong>IV. Come conserviamo e proteggiamo le tue informazioni personali</strong></p>
                <p>Conserviamo le informazioni personali entro il periodo necessario ai fini della raccolta delle informazioni
                    descritti nella presente Informativa Privacy o ottemperiamo ai requisiti legali applicabili. Smetteremo di
                    archiviare le tue informazioni personali e le cancelleremo o le renderemo anonime dopo aver completato lo scopo
                    della raccolta, o dopo aver confermato la tua richiesta di eliminazione o cancellazione, o dopo che avremo
                    interrotto il funzionamento dei prodotti o servizi corrispondenti. Se è per interesse pubblico, ricerca
                    scientifica
                    e storica o per scopi statistici, continueremo a conservare i dati rilevanti in base alle leggi applicabili,
                    anche
                    se l'ulteriore gestione dei dati non ha nulla a che fare con lo scopo della raccolta originale.</p>
                <p>Nel business dell'Dreamehome, il tempo di conservazione specifico dei tuoi dati personali è il seguente:</p>
                <p>Per i dati archiviati localmente nell'Dreamehome, quando si disinstalla l'app o si cancellano i dati dell'app,
                    tutti i dati memorizzati verranno eliminati immediatamente.</p>
                <p>Per i dispositivi intelligenti e i dati aziendali archiviati sul server, quando elimini il dispositivo
                    intelligente, rifiuti di accettare l'Informativa Privacy dell'Dreamehome e interrompi l'utilizzo dei servizi
                    dell'Dreamehome, tutti i dati memorizzati verranno eliminati immediatamente.</p>
                <p>Per i registri aziendali, i dati statistici e i record storici memorizzati sul server, li cancelliamo di tanto in
                    tanto durante la pulizia dei dati del server. Normalmente i dati vengono conservati per non più di 2 anni.</p>
                <p>Inoltre, nel caso in cui Dreame interrompa il funzionamento dei prodotti o servizi corrispondenti, ti informeremo
                    tramite notifiche push, annunci, ecc. E cancelleremo le tue informazioni personali o le renderemo anonime entro
                    un
                    periodo di tempo ragionevole.</p>
                <p><strong>V. I tuoi diritti</strong></p>
                <p>(I) Accesso, rettifica e cancellazione</p>
                <p>In conformità con le leggi e le normative locali applicabili, hai il diritto di richiedere l'accesso, la
                    rettifica
                    o la cancellazione di qualsiasi informazione che raccogliamo da te (di seguito denominata "richiesta"). Scrivici
                    o
                    contattaci visitando l’Dreamehome. Secondo la maggior parte delle leggi, la richiesta di un soggetto di dati
                    personali deve essere conforme ai requisiti specifici.</p>
                <p>Nella presente Informativa Privacy, i requisiti per i soggetti interessati dai dati personali includono:</p>
                <p>La richiesta deve essere effettuata tramite i nostri canali di richiesta dedicati. Per garantire la sicurezza
                    delle
                    tue informazioni personali, la richiesta deve essere in forma scritta (a meno che la legge locale non riconosca
                    chiaramente una richiesta verbale);</p>
                <p>È necessario fornire le informazioni sufficienti per consentirci di verificare la propria identità e garantire
                    che
                    la richiesta sia effettuata dall'utente stesso o da persona legalmente autorizzata dall'utente;</p>
                <p>Una volta acquisite informazioni sufficienti per confermare che possiamo procedere la tua richiesta, ti
                    risponderemo entro il tempo specificato dalle leggi sulla protezione dei dati applicabili. Nello specifico, le
                    nostre risposte includono:</p>
                <p>Sulla base della tua richiesta e delle leggi e dei regolamenti applicabili, possiamo fornirti una copia delle tue
                    informazioni che abbiamo raccolto e gestito gratuitamente. Per altre richieste di informazioni pertinenti,
                    potremmo
                    addebitare una commissione ragionevole basata sui nostri costi di gestione effettivi in conformità con le leggi
                    applicabili.</p>
                <p>Se ritieni che una delle tue informazioni in nostro possesso sia errata o incompleta, puoi richiedere di
                    rettificare o completare le informazioni in base allo scopo di utilizzo.</p>
                <p>In base alle leggi e ai regolamenti applicabili, hai il diritto di richiedere la cancellazione dei tuoi dati
                    personali. La tua richiesta verrà valutata. Se è conforme alle leggi e ai regolamenti corrispondenti,
                    cancelleremo
                    le tue informazioni con procedure pertinenti comprese misure tecnologiche. Dopo che le informazioni pertinenti
                    sono
                    state eliminate da te o da noi con il tuo consenso, potremmo non essere in grado di eliminarle immediatamente
                    dal
                    sistema di backup a causa delle leggi e delle tecnologie di sicurezza pertinenti. In tal caso, proteggeremo le
                    tue
                    informazioni personali e le isoleremo da qualsiasi ulteriore elaborazione fino a quando non potranno essere
                    cancellate o rese anonime. Ad esempio, in base alla legge sul commercio elettronico della Repubblica Popolare
                    Cinese, le informazioni sui prodotti e i servizi e le informazioni sulle transazioni devono essere conservate
                    per
                    almeno tre anni dal giorno del completamento della transazione.</p>
                <p>Abbiamo il diritto di rifiutare di elaborare una richiesta nei seguenti casi: la richiesta è irragionevole o
                    contestata; può danneggiare la privacy degli altri; è estremamente irrealistica; richiede un lavoro tecnico
                    sproporzionato; può essere ignorata secondo le leggi locali; le informazioni sono state divulgate pubblicamente;
                    le
                    informazioni sono state divulgate in condizioni di riservatezza. Se riteniamo che, in alcuni casi, la richiesta
                    di
                    cancellazione o l’accesso ai dati possa impedirci di utilizzare legalmente i dati per le suddette finalità
                    antifrode
                    e di sicurezza, potremmo anche rifiutarla.</p>
                <p>(II) Revoca del consenso</p>
                <p>Puoi revocare il tuo consenso inviando una richiesta, inclusi la raccolta, l'uso e / o la divulgazione delle tue
                    informazioni personali che deteniamo o controlliamo. In base agli specifici servizi che usi, puoi contattarci
                    per le
                    relative operazioni attraverso le informazioni di contatto nella Sezione 7 della presente Politica sulla
                    Privacy.
                    Elaboreremo la tua richiesta entro un tempo ragionevole dopo che hai effettuato la richiesta e non
                    raccoglieremo,
                    useremo e / o divulgheremo più le tue informazioni personali in conformità con la tua richiesta.</p>
                <p>Tieni presente che, a seconda dell'ambito entro il quale ci autorizzi a trattare le tue informazioni, a seguito
                    del
                    tuo ritiro del consenso, potresti non essere in grado di accedere ai servizi dell'Dreamehome o dei suoi
                    dispositivi
                    intelligenti collegati. Tuttavia, la tua decisione di revocare il tuo consenso o l’autorizzazione non influirà
                    sul
                    precedente trattamento dei dati personali basato sulla tua autorizzazione.</p>
                <p>Puoi anche disattivare il Programma di Miglioramento dell'Esperienza Utente richiedendo la revoca del consenso o
                    visitando l'Dreamehome.</p>
                <p>(III) <strong>Cancellazione dell'Account Dreamhome</strong></p>
                <p>Puoi cancellare l'account Dreamhome visitando "Mio" - "Impostazioni dell'Account" - "Cancella l'Account". Se
                    desideri cancellare il tuo account Dreamehome, per favore nota che l'operazione di cancellazione del tuo account
                    Dreamhome ti impedirà di usare Dreamehome e l'intera linea di prodotti e servizi hardware intelligenti e procedi
                    con
                    cautela. Al fine di proteggere i diritti e gli interessi legittimi di te o di altri, determineremo se supportare
                    la
                    tua richiesta di cancellazione in base al tuo uso dei prodotti e dei servizi hardware intelligenti di Dreamhome.
                </p>
                <p><strong>VI. Come gestiamo la trasmissione transfrontaliera dei dati</strong></p>
                <p>Dreame si affida alle sue risorse e ai suoi server in tutto il mondo per fornirti i prodotti e/o servizi.
                    Pertanto,
                    con il tuo consenso, le tue informazioni personali potrebbero essere trasferite ad altre giurisdizioni al di
                    fuori
                    del paese/regione in cui stai utilizzando i prodotti o servizi, o potrebbero essere accessibili da queste
                    giurisdizioni. Le politiche sulla protezione dei dati e le leggi pertinenti nel paese/regione in cui le tue
                    informazioni possono essere trasferite potrebbero non essere così complete come quelle del tuo paese/regione
                    attuale. In tali circostanze, adotteremo misure appropriate e legali in conformità con le leggi applicabili
                    della
                    giurisdizione corrispondente per garantire che le tue informazioni personali continuino ad essere protette.</p>
                <p>Nota:</p>
                <p>Se risiedi nello Spazio Economico Europeo (SEE) e le tue informazioni personali vengono trasferite al di fuori
                    dello SEE, noi: elaboreremo le tue informazioni personali all'interno dell'area in cui la Commissione Europea
                    può
                    fornire un livello di protezione sufficiente; o implementeremo misure di protezione adeguate per salvaguardare
                    le
                    tue informazioni personali, incluso il trasferimento delle tue informazioni in conformità con le normative
                    applicabili sul trasferimento dei dati, come le Clausole Contrattuali Standard (SCC) della Commissione Europea.
                </p>
                <p><strong>VII. Le nostre informazioni di contatto</strong></p>
                <p>In caso di commenti o domande sulla presente Informativa Privacy o sulla nostra raccolta, l’utilizzo o la
                    divulgazione delle tue informazioni personali, ti preghiamo di contattarci tramite le informazioni di contatto
                    di
                    seguito o visitando l'Dreamehome e intitolare il messaggio con "Informativa Privacy". Avremo il nostro team di
                    professionisti per rispondere alle tue domande e problemi. Se la tua domanda riguarda questioni piuttosto
                    importanti, potremmo chiederti di fornire maggiori informazioni. Se non sia soddisfatto/a della nostra risposta,
                    potresti presentare un reclamo all'autorità di controllo competente nella tua giurisdizione. Se ci consulta sui
                    canali di reclamo, ti forniremo le opzioni applicabili in base alla tua situazione attuale.</p>
                <p><strong>Indirizzo email:</strong>:</p>
                <p>Informazioni di contatto in Cina: <a className="page"
                    href="mailto:privacy@dreame.tech">privacy@dreame.tech</a> </p>
                <p>Informazioni di contatto del DPO di Singapore: <a className="page"
                    href="mailto:dpo.sg@dreame.tech">dpo.sg@dreame.tech</a> </p>
                <p>Informazioni di contatto del rappresentante UE: <a className="page"
                    href="mailto:rappresentante.dreame@herrero.es">rappresentante.dreame@herrero.es</a> </p>
                <p><strong>Numero di contatto: </strong>400-875-9511</p>
                <p><strong>Sito web: </strong><a className="page"
                    href="https://www.dreametech.com">https://www.dreametech.com</a></p>
                <p><strong>VIII. Come aggiorniamo i termini</strong></p>
                <p>Dreame si riserva il diritto di aggiornare tempestivamente la presente Informativa Privacy. In caso di modifiche,
                    ti informeremo tramite un messaggio pop-up o altri mezzi importanti. Solo con il tuo consenso raccoglieremo,
                    utilizzeremo e memorizzeremo le tue informazioni personali in conformità con la politica aggiornata.</p>
                <p>Questa politica ha effetto dalla data di aggiornamento.</p>
                <p>Data dell’ultimo aggiornamento: 28/ 08 / 2021</p>
                <p>Appendice I: I Dettagli SDK di Terze Parti</p>
                <p>* L'Dreamehome utilizza una serie di SDK di terze parti per fornire le funzionalità e i servizi di base e quelli
                    aggiuntivi più professionali e più sicuri. Leggi ulteriori dettagli sugli SDK di terze parti utilizzati
                    nell'Dreamehome di seguito:</p>
                <div className='tableStyle'>
                    <table>
                        <tr>
                            <td>
                                <p>SDK</p>
                            </td>
                            <td>
                                <p>Caratteristiche</p>
                            </td>
                            <td>
                                <p>Informazioni Raccolte</p>
                            </td>
                            <td>
                                <p>Informativa Privacy di Terze Parti</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Umeng analisi statistica SDK</p>
                            </td>
                            <td>
                                <p>Analisi statistica</p>
                            </td>
                            <td>
                                <p>Identificatore del dispositivo (IMEI/Mac/ID Android/IDFA/OPENUDID/GUID,IMSI INFO DELLA SIM CARD),
                                    posizione
                                </p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Umeng notifica push SDK</p>
                            </td>
                            <td>
                                <p>Notifica push</p>
                            </td>
                            <td>
                                <p>Identificatore del dispositivo (IMEI/Mac/ID Android/IDFA/OPENUDID/GUID, IMSI INFO DELLA SIM CARD),
                                    posizione
                                </p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Umeng U-share SDK</p>
                            </td>
                            <td>
                                <p>Condivisione con terze parti</p>
                            </td>
                            <td>
                                <p>Identificatore del dispositivo (IMEI/Mac/ID Android/IDFA/OPENUDID/GUID, IMSI INFO DELLA SIM CARD),
                                    posizione
                                </p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>
                                <p>Agora SDK</p>
                            </td>
                            <td>
                                <p>Abilita del collegamento microfono e streaming video</p>
                            </td>
                            <td>
                                <p>Informazioni sul dispositivo, stato della rete, fotocamera, microfono, memoria di lettura e scrittura
                                </p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://www.agora.io/cn/privacy-policy/">https://www.agora.io/cn/privacy-policy/</a></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Huawei data-push SDK</p>
                            </td>
                            <td>
                                <p>Data-push</p>
                            </td>
                            <td>
                                <p>Identificatore del dispositivo</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169">https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169</a>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Xiaomi data-push SDK</p>
                            </td>
                            <td>
                                <p>Data-push</p>
                            </td>
                            <td>
                                <p>Identificatore del dispositivo, modello del dispositivo, tipo di rete, memoria del dispositivo,
                                    informazioni
                                    sul processo in esecuzione sul dispositivo, versione dell'applicazione, versione dell'SDK</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://dev.mi.com/console/doc/detail?pId=1822">https://dev.mi.com/console/doc/detail?pId=1822</a>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>OPPO data-push SDK</p>
                            </td>
                            <td>
                                <p>Data-push</p>
                            </td>
                            <td>
                                <p>Identificatore del dispositivo</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://open.oppomobile.com/wiki/doc#id=10194">https://open.oppomobile.com/wiki/doc#id=10194</a>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>VIVO data-push SDK</p>
                            </td>
                            <td>
                                <p>Data-push</p>
                            </td>
                            <td>
                                <p>Identificatore del dispositivo </p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://dev.vivo.com.cn/documentCenter/doc/366">https://dev.vivo.com.cn/documentCenter/doc/366</a>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>WeChat SDK</p>
                            </td>
                            <td>
                                <p>Accesso a WeChat, Condivisione su WeChat</p>
                            </td>
                            <td>
                                <p>Identificatore del dispositivo, informazioni di rete</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>QQ SDK</p>
                            </td>
                            <td>
                                <p>Condivisione su QQ</p>
                            </td>
                            <td>
                                <p>Identificatore del dispositivo, informazioni di rete</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Weibo SDK</p>
                            </td>
                            <td>
                                <p>Accesso a weibo, Condivisione su weibo</p>
                            </td>
                            <td>
                                <p>Identificatore del dispositivo, informazioni di rete</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE">https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE</a>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Apple ID SDK</p>
                            </td>
                            <td>
                                <p>Accesso a Apple ID </p>
                            </td>
                            <td>
                                <p>Apple ID</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://www.apple.com/legal/privacy/szh/">https://www.apple.com/legal/privacy/szh/</a></p>
                            </td>
                        </tr>
                    </table>
                </div>
                <div className='height'></div>
            </body>
        </div>
    )
}

export default PricacyPolicy